import script from "./OrderDetailsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetailsSection.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetailsSection.vue?vue&type=style&index=0&id=3149c3c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3149c3c7"]])

export default __exports__